import axios from "axios";
import store from "../store";
import { logout } from "../actions/authActions";

const api = axios.create({
  headers: {
    "X-Tenant": process.env.REACT_APP_TENANT
  }
});
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers["x-auth-session"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      store.dispatch(logout());
      return Promise.resolve();
    }
    return Promise.reject(error);
  }
);

const apiService = {
  login: (form) => api.post("/api/login/auth/login", form),
  logout: () => api.get("/api/login/auth/logout"),
  getEmailBySsn: (form) => api.post("/api/login/auth/get-email-by-ssn", form),
  getProfile: () => api.get("/api/login/account"),
  getLoanData: (date) => api.get(`/api/login/loan/data?paymentDate=${date}`),
  getLoanLastActivity: () => api.get(`/api/login/loan/apply/last-activity`)
    .catch((error) => error.response && error.response.status === 404 ? { data: {} } : error),
  applyNewLoan: (form) => api.post(`/api/login/loan/apply/new`, form),
  getCustomerData: () => api.get(`/api/login/account/apply-form-data`),
  getPaymentFormData: (amount) => api.get(`/api/login/payment/form-data?amount=${amount}`),
  getBillingInfo: () => api.get(`/api/login/payment/billing-info`),
  updateBillingInfo: (form) => api.post(`/api/login/payment/billing-info`, form),
  getPaymentInfo: () => api.get(`/api/login/payment/payment-info`),
  removePaymentInfo: (id) => api.delete(`/api/login/payment/payment-info/${id}`),
  updatePrimaryPayment: (id) => api.put(`/api/login/payment/payment-info/${id}/primary`, null),
  handlePaymentSubmit: () => api.post(`/api/login/payment/submit`, null),
  completePayment: (form) => api.post(`/api/login/payment/complete`, form),
  getPaymentLastActivity: () => api.get(`/api/login/payment/last-activity`)
    .catch((error) => error.response && error.response.status === 404 ? { data: {} } : error),
  getActivities: () => api.get(`/api/login/activities`),
  requestCallback: (form) => api.post("/api/login/account/request-callback", form)
};

export default apiService;
